/**
 * @generated SignedSource<<85aa4217ef58f16fb88e451aee6d9e5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MovementsModal_movementStep$data = {
  readonly id: string;
  readonly description: string;
  readonly " $fragmentType": "MovementsModal_movementStep";
};
export type MovementsModal_movementStep$key = {
  readonly " $data"?: MovementsModal_movementStep$data;
  readonly " $fragmentSpreads": FragmentRefs<"MovementsModal_movementStep">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MovementsModal_movementStep"
};

(node as any).hash = "f9a14f4a0ed3de7a943897f0b60cfd12";

export default node;
